module.exports = __webpack_public_path__ + "static/media/card_white_no_shape.0855e67a.svg";